import { combineReducers } from "redux";
import counterReducer from "./counterReducer";
import usageLocationReducer from "./usageLocationReducer";

const rootReducer = combineReducers({
  counter: counterReducer,
  usageLocations: usageLocationReducer,
});

export default rootReducer;
